"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _jsxRuntime = require("react/jsx-runtime");

var _excluded = ["children", "style", "minHeight", "padding", "margin", "className", "borderRadius", "colorBackground", "colorText", "boxShadow", "border", "transition"];

var _templateObject;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var StyledCard = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: relative;\n  min-height: ", ";\n  margin: ", ";\n  padding: ", ";\n  border-radius: ", ";\n  box-shadow: ", ";\n  background: ", ";\n  color: ", ";\n  border: ", ";\n  transition: ", ";\n"])), function (props) {
  return props.minHeight;
}, function (props) {
  return props.margin;
}, function (p) {
  return p.padding;
}, function (p) {
  return p.borderRadius || p.theme.borderRadius;
}, function (p) {
  return p.boxShadow || p.theme.boxShadowCard;
}, function (p) {
  return p.colorBackground || p.theme.colorCardBackground;
}, function (p) {
  return p.colorText || p.theme.colorText;
}, function (p) {
  return p.border;
}, function (p) {
  return p.transition;
});

var Card = function Card(_ref) {
  var children = _ref.children,
      style = _ref.style,
      minHeight = _ref.minHeight,
      padding = _ref.padding,
      margin = _ref.margin,
      className = _ref.className,
      borderRadius = _ref.borderRadius,
      colorBackground = _ref.colorBackground,
      colorText = _ref.colorText,
      boxShadow = _ref.boxShadow,
      border = _ref.border,
      transition = _ref.transition,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledCard, {
    className: className,
    style: style,
    padding: padding,
    margin: margin,
    minHeight: minHeight,
    borderRadius: borderRadius,
    colorBackground: colorBackground,
    colorText: colorText,
    boxShadow: boxShadow,
    border: border,
    transition: transition,
    children: children
  });
};

Card.defaultProps = {
  minHeight: "auto",
  padding: "1.5rem 1rem",
  margin: "0 1rem 1rem",
  border: "none",
  transition: "none"
};
Card.propTypes = {
  colorBackground: _propTypes.default.string,
  colorText: _propTypes.default.string,
  minHeight: _propTypes.default.string,
  padding: _propTypes.default.string,
  margin: _propTypes.default.string,
  borderRadius: _propTypes.default.string,
  boxShadow: _propTypes.default.string,
  border: _propTypes.default.string,
  transition: _propTypes.default.string
};
var _default = Card;
exports.default = _default;